import { Modal } from 'component/Modal'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { employeeModal } from 'page/catalog/employee/EmployeeModal/EmployeeModalStore'
import { ChangeStep } from 'page/catalog/employee/EmployeeModal/step/ChangeStep'
import { LoginStep } from 'page/catalog/employee/EmployeeModal/step/LoginStep'
import { LogoutStep } from 'page/catalog/employee/EmployeeModal/step/LogoutStep'
import { employee } from 'page/catalog/employee/store/EmployeeStore'
import { ReactElement } from 'react'

function title(): string {
  const { step } = employeeModal.it
  switch (step) {
    case 'login':
      return i18n('EmployeeLogin')
    case 'change':
      return i18n('ChangeAccount')
    case 'logout':
      return i18n('Employee')
    default:
      return ''
  }
}

function content(): ReactElement {
  const { step } = employeeModal.it
  switch (step) {
    case 'login':
      return <LoginStep />
    case 'change':
      return <ChangeStep />
    case 'logout':
      return <LogoutStep />
    default:
      return <div />
  }
}

export const EmployeeModal = observer(() => {
  const onClose = useLatestCallback(() => {
    if (employee.user) employeeModal.close()
  })

  return (
    <Modal open={true} white title={title()} width={400} onCancel={onClose} closeButton={false}>
      {content()}
    </Modal>
  )
})
